<template>
  <div class="w-full overflow-hidden rounded-lg">
    <div class="w-full overflow-y-auto">
      <table class="w-full">
        <thead>
          <tr>
            <th>Best</th>
            <th>Fim</th>
            <th>Resultado</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in getBestsHistory"
            :key="item.bo_id"
            role="button"
            @click="openOrderDetails(item)"
          >
            <td>
              <div class="flex flex-col gap-1">
                <span class="text-sm font-bold leading-none">
                  {{ item.label }}
                </span>
                <span class="text-xs"> {{ item.bo_target }}p </span>
              </div>
            </td>
            <td class="align-top">
              <div class="flex flex-col gap-1 text-xs">
                <template v-if="item.bo_exit_datetime">
                  <span>
                    {{ moment(item.bo_exit_datetime).format("DD/MM/YYYY") }}
                  </span>
                  <span>
                    {{ moment(item.bo_exit_datetime).format("HH:mm:ss") }}
                  </span>
                </template>
                <span v-else>-</span>
              </div>
            </td>
            <td class="align-top">
              <div class="flex items-center gap-2">
                <div class="h-3 w-3">
                  <i v-if="item.bo_profit > 0" v-html="$icons.play_green"></i>
                  <i
                    v-else-if="item.bo_profit < 0"
                    v-html="$icons.play_red"
                  ></i>
                  <i
                    v-else-if="
                      item.bo_profit == 0 ||
                      item.bo_profit == null ||
                      item.bo_profit == NaN
                    "
                  >
                    <span class="h-3 w-3 rounded-full bg-gray-500"></span>
                  </i>
                </div>
                <span>
                  <template
                    v-if="
                      typeof item.bo_profit == 'number' && item.bo_profit != NaN
                    "
                  >
                    {{ item.bo_profit | currency }}
                  </template>
                  <template v-else>
                    {{ 0 | currency }}
                  </template>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <portal to="modal">
      <best-order-details-component
        :active="details_drawer_is_active"
        :data="order_details"
        @close="details_drawer_is_active = false"
      />
    </portal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import symbol_images from "../symbol_images";
import bestOrderDetailsComponent from "./best-order-details.component.vue";
export default {
  mixins: [symbol_images],

  components: { bestOrderDetailsComponent },

  data() {
    return {
      details_drawer_is_active: false,
      order_details: null,
    };
  },

  computed: {
    ...mapGetters({ getBestsHistory: "bests/getBestsHistory" }),
  },

  methods: {
    openOrderDetails(order) {
      this.order_details = order;
      this.details_drawer_is_active = true;
    },
  },
};
</script>

<style lang="scss" scoped>
th {
  @apply bg-ontick-steel-600 px-3 py-2 text-left text-sm;
}
td {
  @apply bg-ontick-graphite-600 overflow-hidden px-3 py-2 text-left text-xs;
}
</style>
